import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DwConfigService, DwConfigServiceToken, SuppressErrorMessagesHeader } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';

export interface Announcement {
    AnnouncementId: number;
    Title: string;
    Summary: string;
    Body?: string;
    PublishedDate?: string;
}

@Injectable({ providedIn: 'root' })
export class AnnouncementsService {
    constructor(private http: HttpClient, @Inject(DwConfigServiceToken) private config: DwConfigService) {}
    // No response cache: each reload observes publication windows and the caller's CAP identity.
    read(challengeId: number): Observable<Announcement[]> {
        return this.http.get<Announcement[]>(this.config.coreConfig.apiRoot.replace(/\/$/, '') + '/fitness/announcements/' + challengeId,
            { headers: { [SuppressErrorMessagesHeader]: 'true' } });
    }
}
